module.exports = __webpack_public_path__ + "img/stamp.0c44c88f.png";